import React from "react";
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { postBankHoliday } from "../../services/BankHolidaysService";
import { Alert } from 'react-bootstrap';

function BankHolidaysForm() {

    let [name, setName] = useState("");
    let [date, setDate] = useState("");
    const [isValidDate, setIsValidDate] = useState(true);

    const [showSuccess, setShowSuccess] = useState(false);
    const handleCloseSuccess = () => {
        setShowSuccess(false);
        window.location.reload();
    }
    const handleShowSuccess = () => {
        setShowError(false);
        setShowSuccess(true);
    };

    const [showError, setShowError] = useState(false);
    const handleCloseError = () => setShowError(false);
    const handleShowError = () => {
        setShowSuccess(false);
        setShowError(true);
    }

    const isValidDateFormat = (dateString) => {
        let regEx = /^\d{4}-\d{2}-\d{2}$/;
        if(!dateString.match(regEx)) return false;
        let d = new Date(dateString);
        let dNum = d.getTime();
        if(!dNum && dNum !== 0) return false;
        return d.toISOString().slice(0,10) === dateString;
    }

    const handleChangeDate = (e) => {
        setDate(e.target.value);
        setIsValidDate(isValidDateFormat(e.target.value));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let formData = {
            name: name,
            date: date
        }
        postBankHoliday(JSON.stringify(formData)).then(function(response) {
            if(response === undefined){
                handleShowError();
            } else {
                if(response.status === 200) {
                    handleShowSuccess();
                } else {
                    handleShowError();
                }
            } 
        });
    }

    return (
        <div className="container home">
            <Alert variant="success" show={showSuccess} onClose={handleCloseSuccess} dismissible>
                <p>
                Festivo creado correctamente.
                </p>
            </Alert>
            <Alert variant="danger" show={showError} onClose={handleCloseError} dismissible>
                <p>
                Se ha producido un error.
                </p>
            </Alert>
            <h1 className="font-weight-light">Crear día festivo</h1>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Nombre de la festividad</Form.Label>
                <Form.Control 
                    required
                    placeholder="Nombre" 
                    value={name}
                    onChange={e => setName(e.target.value)}
                />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicDate">
                <Form.Label>Fecha</Form.Label>
                <Form.Control placeholder="2023-04-21" 
                    required
                    value={date}
                    onChange={handleChangeDate}
                    isInvalid={!isValidDate}
                />
                <Form.Control.Feedback type="invalid">
                    La fecha tiene que tener formato yyyy-mm-dd
                </Form.Control.Feedback>
                </Form.Group>

                <Button variant="primary" type="submit">
                Enviar
                </Button>
            </Form>
        </div>
    );
}

export default BankHolidaysForm;